import { mobileDefaults, tierDefaults } from './gradient.js'

function mobile(deviations = {}) {
  return { ...mobileDefaults, ...deviations }
}
function desktop(mobileDeviations = {}, desktopOverride = {}) {
  return {
    ...mobileDefaults,
    ...tierDefaults.desktop,
    ...mobileDeviations,
    ...desktopOverride,
  }
}

const onboardingMobile = mobile({ angle: 180 })
const onboardingDesktop = desktop({ angle: 180 })

const votingMobileCfg = mobile({ angle: 170 })
const votingDesktopCfg = desktop({ angle: 135 })

const paymentMobileCfg = mobile({ angle: 10 })
const paymentDesktopCfg = desktop({ angle: 45 })

export const types = {
  onboarding: [
    [1025, onboardingMobile],
    [Infinity, onboardingDesktop],
  ],
  voting: [
    [1025, votingMobileCfg],
    [Infinity, votingDesktopCfg],
  ],
  payment: [
    [1025, paymentMobileCfg],
    [Infinity, paymentDesktopCfg],
  ],
}
